const addInfo = {
  title: 'ColdChainMonitoring',
  icon: 'cold-chain'
}
// const coldChainMonitoringRouter = {
//   path: '/cold-chain-monitoring',
//   component: () => import('@/views/ColdChainMonitoring/cold-chain-monitoring'),
//   name: 'ColdChainMonitoring',
//   meta: { title: 'ColdChainMonitoring', icon: 'cold-chain', parent: addInfo }
// }
const coldChainMonitoringRouter = {
  path: '/cold-chain-monitoring',
  meta: {
    title: 'ColdChainMonitoring',
    icon: 'cold-chain',
    permission: ['cold_chain_monitoring'],
  },
  children: [
    {
      path: '',
      component: () => import('@/views/ColdChainMonitoring/cold-chain-dashboard'),
      name: 'ColdChainMonitoring',
      meta: { title: 'ColdChainMonitoring', parent: addInfo, permission: ['cold_chain_monitoring'] },
    },
    {
      path: 'temperature-detail',
      component: () => import('@/views/ColdChainMonitoring/temperature-detail.vue'),
      name: 'ColdChainTemperatureDetail',
      hidden: true,
      meta: {
        title: 'TemperatureDetails',
        parent: addInfo,
        activeMenu: '/cold-chain-monitoring',
        enableBack: true,
        backPage: 'ColdChainMonitoring',
        permission: ['cold_chain_monitoring'],
      },
    },
  ],
}
export default coldChainMonitoringRouter